/**
 * Mobile PurchaseFlow Module
 *
 * Provides mobile-specific components and utilities for the purchase flow.
 *
 * Components:
 * - MobilePurchaseFlow: Wrapper that handles mobile app messaging
 *
 * Utilities:
 * - postMessageToApp: Direct message posting to native app
 * - send*: Convenience functions for common messages
 *
 * No Redux required - reads from URL params and posts messages directly.
 */

// ============================================================================
// Components
// ============================================================================

export { MobilePurchaseFlow } from './MobilePurchaseFlow';

// ============================================================================
// Messaging Utilities
// ============================================================================

export {
  // Core posting function
  postMessageToApp,
  buildMessage,
  // Convenience functions
  sendInitialLoaded,
  sendPayCompleted,
  sendDismiss,
  sendNavigationUpdate,
  sendAnalytics,
  // Message keys
  messageToAppKeys
} from './mobileMessaging';
